module.exports = __webpack_public_path__ + "img/jf.bade27f.png";